import React from 'react';

function DefaultError() {
  return (
    <div className="error-boundary">
      <p className="error-boundary__message">We have a problem...</p>
    </div>
  );
}

export default DefaultError;



// WEBPACK FOOTER //
// ./src/views/components/error_boundary/default_error.js